import UsersList from "@/components/elements/UsersListe";
import BoatsList from "@/components/elements/BoatList";
import {AdminProvider} from "../../../contexts/AdminContext"

import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Container from 'react-bootstrap/Container';


export default function AdminPage() {

  return (
    <AdminProvider>
        <Card>
          <Card.Header>
            <h1 className="mb-0 fs-1">Administration</h1>
          </Card.Header>
          <Card.Body>
            <div>
              <div className="col-lg-12 col-sm-6">
                <UsersList/>
              </div>
              <div className="col-lg-12 col-sm-6">
                <BoatsList/>
              </div>
            </div>
          </Card.Body>
        </Card>
    </AdminProvider>
  );
}
